import request from '@/utils/request'

export function findExpressSenders(params) {
  return request({
    url: `/express_senders`,
    method: 'get',
    params: params
  })
}

export function findDefaultExpressSender() {
  return request({
    url: `/express_senders/default`,
    method: 'get'
  })
}

export function createExpressSender(data) {
  return request({
    url: `/express_senders`,
    method: 'post',
    data
  })
}

export function findExpressSenderForm(id) {
  return request({
    url: `/express_senders/${id}/form`,
    method: 'get'
  })
}

export function updateExpressSender(id, data) {
  return request({
    url: `/express_senders/${id}`,
    method: 'put',
    data
  })
}

export function updateExpressSenderEffective(id, data) {
  return request({
    url: `/express_senders/${id}/effective`,
    method: 'patch',
    data
  })
}

export function updateExpressSenderIsDefault(id, data) {
  return request({
    url: `/express_senders/${id}/is_default`,
    method: 'patch',
    data
  })
}
